import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SessionManagerService } from "../../_services/SessionManager/session-manager.service";
import { LoggerService } from "../../modules/logger/logger.service";
import { TranslationService } from "../../_services/translation.service";
import { ITranslations } from "../../_models/ITranslations";
import { Observable } from "rxjs/Observable";
import Player = YT.Player;

@Component({
  selector: "contribution",
  templateUrl: "contribution.component.html",
  styleUrls: ["./contribution.component.scss"],
})
export class ContributionComponent {
  public player: Player;

  @Input() public contribution: any;
  @Input() public videoId: any;
  @Input() public loadingContribution1: boolean;
  @Input() public loadingContribution2: boolean;
  @Input() public loadingContribution3: boolean;
  @Input() public loadingContribution4: boolean;

  public showContribution: boolean = true;

  @Output() public clickedAddContribution = new EventEmitter<{
    price: number;
    index: number;
    fromModal: boolean;
  }>();
  public translations$: Observable<ITranslations>;

  constructor(
    private sessionManger: SessionManagerService,
    private translationService: TranslationService,
    private logger: LoggerService
  ) {
    this.translations$ = this.translationService.translations;
  }

  public closeContribution() {
    this.showContribution = false;
  }

  public addContribution(price: number, index: number, fromModal: boolean) {
    this.clickedAddContribution.emit({ price, index, fromModal });
  }

  public openContribution() {
    this.showContribution = true;
  }

  public onReady(player) {
    if (this.sessionManger.isDevModeActive()) {
      return;
    }
    this.player = player;
    this.player.setVolume(9);
    this.player.setLoop(true);
    this.player.playVideo();
  }

  public onStateChange(_event) {
    return void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/checkout/contribution/contribution.component.ts